module.exports = __webpack_public_path__ + "static/media/cartoon_bg_xiazai.131f19ed.png";